import { Component, OnInit, Injectable } from '@angular/core';
import { UserSite } from '../../../shared/models/UserSite';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UsersSiteService } from '../../../shared/services/usersSite.service';
import { UrlService } from '../../../shared/services/url.service';

@Component({
  selector: 'app-usersSiteFilter',
  templateUrl: '../templates/usersSiteFilter.component.html'
})

@Injectable()
export class UsersSiteFilterComponent implements OnInit {

  title = 'Users Filter';
  Users: UserSite[];
  DashboardUrl = '';
  selectedEmail = '';

  constructor(
    private urlService: UrlService,
    private usersSiteService: UsersSiteService,
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.Init();
  }

  Init(): void {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
  };

  Filter(): void {
    this.alertService.removeAll();
    this.Users = [];
    const usersFilter: any = this.getFilterRequest();
    this.usersSiteService.FindByEmail(usersFilter.Email).subscribe(users => {
      if (users.length > 0) {
        this.Users = users;
      }
    });
  };

  getFilterRequest(): Object {
    return {
      Email: this.selectedEmail
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/users/components/scripts/usersSiteFilter.component.ts